import { Spinner } from '@wartek-id/spinner'

import KinerjaSidebar from 'app/KinerjaShared/components/KinerjaSidebar'
import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import KepalaSekolahRootView from 'app/KinerjaPage/components/KepalaSekolahRootView'
import { usePengelolaanKinerjaBaseUrl } from 'app/KinerjaShared/hooks/usePengelolaanKinerjaBaseUrl'

interface BerandaKepalaSekolahPenilaiProps {
  isKinerjaPelaksanaanEnabled?: boolean
  isKinerjaPenilaianDemoEnabled?: boolean
}

const BerandaKepalaSPNFPenilai = ({
  isKinerjaPelaksanaanEnabled = false,
}: BerandaKepalaSekolahPenilaiProps) => {
  const { isLoading, profile } = useRoleContext()
  const { periods } = usePeriodContext()

  const isPeriodResolved = Array.isArray(periods) && periods.length > 0
  const isNotReady = isLoading || !isPeriodResolved
  const baseUrl = usePengelolaanKinerjaBaseUrl()

  return (
    <div className="pl-64">
      <KinerjaSidebar sticky activeMenu="kepala-skb-penilai" />
      <div className="p-6 flex flex-col gap-6 w-full">
        {isNotReady ? (
          <div className="w-full flex justify-center">
            <Spinner />
          </div>
        ) : (
          <>
            <KepalaSekolahRootView
              baseUrl={baseUrl}
              profile={profile}
              isKinerjaPelaksanaanEnabled={isKinerjaPelaksanaanEnabled}
              isLoading={isLoading}
              roleType="KSPNF"
              additionalCardProps={{
                title: 'Periksa Perencanaan Kinerja Pamong',
                badgeText: 'Khusus Kepala Sekolah Non Formal',
              }}
            />
          </>
        )}
      </div>
    </div>
  )
}

export default BerandaKepalaSPNFPenilai
